import React, { Fragment, useEffect, useRef, useState } from "react"
import { FaSearch } from "react-icons/fa"
import isURL from "validator/lib/isURL"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import FuwFooter from "./FuwFooter"
import { Button, TextField } from "components"
import classes from "./FuwLinks.module.scss"

const FuwLinks = props => {
  const {
    setTab,
    setFiles,
    numberOfFiles,
    originalFiles
  } = props

  const [t] = useTranslation()

  const [link, setLink] = useState("")
  const [error, setError] = useState("")
  const [sending, setSending] = useState(false)

  const unmount = useRef(false)

  const handleChange = (e) => {
    setLink(e.target.value)
  }

  const getUrlFileName = (url) => (
    url.split('/').pop().split("?")[0]
  )

  const handleDownloadFile = async () => {
    if (!isURL(link)) {
      return setError(t("لینک_صحیح_نیست"))
    }

    const fileName = getUrlFileName(link)

    setSending(true)

    try {
      const image = await fetch(link)

      const blob = await image.blob()

      if (unmount.current) return

      const file = {
        id: (Math.random() * 10000) | 0,
        edited: false,
        isFile: true,
        blob,
        url: URL.createObjectURL(blob),
        name: fileName,
        size: blob.size,
        type: blob.type,
        uploadProgress: 0,
        uploadFailed: false
      }

      setFiles(prev => {
        const newFiles = [...prev, file]

        originalFiles.current = newFiles

        return newFiles
      })

      setTab("files")
    } catch (err) {
      console.log(err)

      setError(t("دانلود_فایل_به_مشکل_خورد"))
    }

    setSending(false)
  }

  useEffect(() => {
    unmount.current = false

    return () => {
      unmount.current = true
    }
  }, [])

  const showFooter = numberOfFiles > 0

  return (
    <Fragment>
      <div
        className={clsx(
          classes["container"],
          showFooter && classes["shrink"]
        )}
      >
        <div className={classes["wrapper"]}>
          <div className={classes["input-wrapper"]}>
            <TextField
              placeholder={t("لینک_فایل_را_وارد_کنید")}
              value={link}
              error={error}
              className={classes["input-container"]}
              inputClassName={classes["input"]}
              onChange={handleChange}
            />
            <Button
              loading={sending}
              className={classes["button"]}
              onClick={handleDownloadFile}
            >
              <FaSearch />
            </Button>
          </div>
        </div>
      </div>

      {
        numberOfFiles > 0 &&
        <FuwFooter
          setTab={setTab}
          numberOfFiles={numberOfFiles}
        />
      }
    </Fragment>
  )
}

export default FuwLinks